import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

// xof_rate : combien d'unités locales pour 1 FCFA (XOF)
const DEFAULTS = {
  CI: { name: "Côte d'Ivoire", currency: "FCFA", currency_code: "XOF", flag: "🇨🇮", cities: ["Abidjan","Bouaké","Daloa","Yamoussoukro","San-Pédro"], phone_prefix: "+225", xof_rate: 1    },
  GN: { name: "Guinée",         currency: "GNF",  currency_code: "GNF", flag: "🇬🇳", cities: ["Conakry","Kankan","Labé","N'Zérékoré","Kindia"],          phone_prefix: "+224", xof_rate: 14   },
};

/** Convertit un montant FCFA vers la devise locale du pays */
export function convertFromFCFA(amountFCFA, config) {
  return Math.round(amountFCFA * (config.xof_rate || 1));
}

/** Formate un montant FCFA dans la devise locale */
export function formatLocal(amountFCFA, config) {
  const converted = convertFromFCFA(amountFCFA, config);
  return new Intl.NumberFormat("fr-FR").format(converted) + " " + config.currency;
}

function detectCountry() {
  const host = window.location.hostname;
  if (host.includes("lmp-gn") || host.includes(".gn") || host.includes("conakry")) return "GN";
  const stored = localStorage.getItem("lmp_country");
  if (stored && DEFAULTS[stored]) return stored;
  return "CI";
}

const CountryContext = createContext({ country: "CI", config: DEFAULTS.CI, setCountry: () => {} });

export function CountryProvider({ children }) {
  const [country, setCountryState] = useState(detectCountry);
  const [config, setConfig]   = useState(DEFAULTS[detectCountry()] || DEFAULTS.CI);

  const setCountry = (cc) => {
    if (!DEFAULTS[cc]) return;
    localStorage.setItem("lmp_country", cc);
    setCountryState(cc);
  };

  useEffect(() => {
    const base = DEFAULTS[country] || DEFAULTS.CI;
    api.get("/config", { headers: { "X-Country-Code": country } })
      .then(r => setConfig({ ...base, ...r.data }))   // on préserve xof_rate du DEFAULTS
      .catch(() => setConfig(base));
  }, [country]);

  // Injecter X-Country-Code sur tous les appels API
  useEffect(() => {
    const id = api.interceptors.request.use((cfg) => {
      cfg.headers["X-Country-Code"] = country;
      return cfg;
    });
    return () => api.interceptors.request.eject(id);
  }, [country]);

  return (
    <CountryContext.Provider value={{ country, config, setCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  return useContext(CountryContext);
}

/** Formate un montant avec la devise du pays actif */
export function useFormatCurrency() {
  const { config } = useCountry();
  return (n) => new Intl.NumberFormat("fr-FR").format(Math.round(n || 0)) + " " + config.currency;
}
